import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { getSavedCases } from "../store/tasks/thunks";
import { selectTasksState } from "../store/tasks/selectors";

export const useTaskCases = () => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { casesByTenants } = useSelector(selectTasksState);

  useEffect(() => {
    if (selectedTenantId && !casesByTenants?.[selectedTenantId]) {
      dispatch(
        getSavedCases({
          tenant_id: selectedTenantId,
        }),
      );
    }
  }, [selectedTenantId, casesByTenants]);

  const cases = useMemo(() => {
    return casesByTenants[selectedTenantId] || [];
  }, [casesByTenants, selectedTenantId]);

  const casesOptions = useMemo(() => {
    return (
      cases.map(({ case_type, display_id, id }) => ({
        label: `#${display_id} ${case_type}`,
        value: id,
      })) || []
    );
  }, [cases]);

  return { casesOptions, cases, selectedTenantId };
};
